package fr.frux.shared.domain.session

import fr.frux.shared.domain.model.User

/**
 * Single source of truth for the authentication state of the app.
 *
 * The app must never read token presence directly: it observes
 * [SessionStore.state] and reacts to these states instead.
 */
sealed interface SessionState {
    /** Session not restored yet — show a splash/loading, never a real screen. */
    data object Unknown : SessionState

    /** No session: the user is browsing anonymously. */
    data object Anonymous : SessionState

    /** A valid session with the logged-in user. */
    data class Authenticated(val user: User) : SessionState

    /** The stored session was rejected by the backend (expired or corrupt token). */
    data object Expired : SessionState
}
